// ════════════════════════════════════════════════════════════════════
// src/permissoes.js — quem enxerga o quê
// ════════════════════════════════════════════════════════════════════
// ÚNICA fonte de verdade do front: menu, guarda de rota e tela de Equipe
// leem daqui. Mudou um papel? Muda só este arquivo.
//
// ⚠️ AS REGRAS DO FIRESTORE REPETEM ESTA MATRIZ.
// Esconder a tela é cosmético: quem souber a URL continua chegando no
// dado. Quem bloqueia de verdade é a regra. Então toda vez que você
// mexer na lista de áreas de um papel aqui, mexa também no bloco
// correspondente do firestore.rules — e publique.
// ════════════════════════════════════════════════════════════════════

// Área = um pedaço do sistema. Não é a mesma coisa que rota: Clientes e
// Chamados moram na mesma tela, e os três extratores dividem uma área só.
export const AREAS = {
  home:        'Início',
  leads:       'Extratores e Meus Leads',
  kanban:      'Kanban',
  clientes:    'Clientes',
  financeiro:  'Valores e MRR',
  chamados:    'Chamados',
  disparo:     'Disparos',
  // WhatsApp não lê o Firestore: quem barra de verdade é o n8n ("FaLei
  // Portal · WhatsApp API", PAPEIS_COM_ACESSO). Mudou aqui, muda lá.
  whatsapp:    'WhatsApp',
  calculadora: 'Calculadora',
  migrador:    'Migrador',
  carteira:    'Atualizar carteira',
  relatorios:  'Relatórios',
  config:      'Configurações',
  equipe:      'Equipe',
};

export const PAPEIS = {
  admin: {
    label: 'Administrador',
    cor: '#6c47ff',
    desc: 'Faz tudo: conecta aparelhos, atualiza a carteira, vê relatórios e gerencia a equipe.',
    areas: Object.keys(AREAS),
  },
  vendas: {
    label: 'Vendas',
    cor: '#059669',
    desc: 'Prospecta e vende: extratores, leads, Kanban, clientes, disparos, WhatsApp, calculadora e migrador. Conecta e reconecta aparelhos (remover é só do Administrador). Não vê relatórios.',
    areas: ['home', 'leads', 'kanban', 'clientes', 'financeiro', 'chamados', 'disparo', 'whatsapp', 'calculadora', 'migrador', 'config'],
  },
  suporte: {
    label: 'Suporte',
    cor: '#d97706',
    desc: 'Atende quem já é cliente: base de clientes, chamados, WhatsApp, Kanban e criação de leads. Não enxerga valores — nem o MRR, nem o valor negociado.',
    areas: ['home', 'leads', 'kanban', 'clientes', 'chamados', 'whatsapp'],
  },
};

export const PAPEL_PADRAO = 'suporte';

// Rota → área. O que não estiver aqui é tratado como livre (ex.: /login).
export const ROTA_AREA = {
  '/':             'home',
  '/maps':         'leads',
  '/instagram':    'leads',
  '/meus-leads':   'leads',
  '/kanban':       'kanban',
  '/clientes':     'clientes',
  '/carteira':     'carteira',
  '/disparo':      'disparo',
  '/agendamentos': 'disparo',
  '/whatsapp':     'whatsapp',
  '/calculadora':  'calculadora',
  '/migrador':     'migrador',
  '/relatorios':   'relatorios',
  '/config':       'config',
  '/equipe':       'equipe',
};

export const podeArea = (papel, area) => {
  if (!area) return true;                       // rota sem área = livre
  const p = PAPEIS[papel];
  if (!p) return false;                         // papel desconhecido = nada
  return p.areas.includes(area);
};

export const labelPapel  = (papel) => PAPEIS[papel]?.label || papel || '—';
export const corPapel    = (papel) => PAPEIS[papel]?.cor   || '#9898b8';
export const areasDoPapel = (papel) => (PAPEIS[papel]?.areas || []).filter(a => a !== 'home');
